import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { GradingConfiguration } from "@types";

export const useGetGradingConfigurations = () => {
  const axios = useAxios();

  const getGradingConfigurations = async (): Promise<GradingConfiguration[]> => {
    const response = await axios.get("/api/grading/configurations");
    return response.data;
  };

  return useQuery({
    queryKey: ["gradingConfigurations"],
    queryFn: getGradingConfigurations,
  });
};
